import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getBalance} from "../store/actions/balanceActions";
import {translateOptions} from "../config";

function Balance() {

    // Импорт диспатчера
    const dispatch = useDispatch();

    // Подписка на изменение стейта тикера
    const balance = useSelector(state => state.balance);
    const ticker = useSelector(state => state.ticker);


    // Получение данных тикера
    useEffect(() => {
        dispatch(getBalance());
    }, []);

    function SetBalance() {

        function setNumber(number,count) {
            if (number === null) {
                return ''
            }

            return number.toFixed(count)
        }

        return <div className="account-table">
            <div className="account-table__row account-table__row--5-col">
                <div className="account-table__cell account-table__cell--fill"></div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-name account-table__cell-name--center">{translateOptions.tickerAv}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-name account-table__cell-name--center">{translateOptions.tickerInOrder}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-name account-table__cell-name--center">{translateOptions.tickerAmount}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill"></div>

            </div>
            <div className="account-table__row account-table__row--5-col">
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-name account-table__cell-name--center">USDT</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-value account-table__cell-value--center">{setNumber(+balance.USDT.free, 2)}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-value account-table__cell-value--center">{setNumber(+balance.USDT.locked, 2)}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-value account-table__cell-value--center">{setNumber(+balance.USDT.total, 2)}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-name account-table__cell-name--center">{translateOptions.tickerInUSDT}</div>
                </div>
            </div>
            <div className="account-table__row account-table__row--5-col">
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-name account-table__cell-name--center">BTC</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-value account-table__cell-value--center">{setNumber(+balance.BTC.free, 6)}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-value account-table__cell-value--center">{setNumber(+balance.BTC.locked, 6)}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-value account-table__cell-value--center">{setNumber(+balance.BTC.total, 6)}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-name account-table__cell-name--center">{translateOptions.tickerInBTC}</div>
                </div>
            </div>
            <div className="account-table__row account-table__row--5-col">
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-name account-table__cell-name--center">{translateOptions.tickerRate}</div>
                </div>
                <div className="account-table__cell account-table__cell--fill">
                    <div className="account-table__cell-value account-table__cell-value--center">{setNumber(+ticker.lastPrice, 2)}</div>
                </div>
            </div>
        </div>;
    }


    return (
        <SetBalance/>
    );
}

export default Balance;
